import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as Actions from 'state/actions'
import Menu from 'general/components/Menu/Menu.component'

const mapStateToProps = state => {
  return {
    isSidebarMenuExpanded: state.ui.isSidebarMenuExpanded
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onToggleExpand: () => dispatch(Actions.toggleExpandMenu())
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Menu))
